// ============================================================
// ProgramInfo.js
// ============================================================
import React, { useEffect, useState } from 'react';
import { useApi } from '../hooks/useApi';
import { useAuth } from '../context/AuthContext';
import { Save, Calendar } from 'lucide-react';
import toast from 'react-hot-toast';

export function ProgramInfo() {
  const api = useApi();
  const { can } = useAuth();
  const [requests, setRequests] = useState([]);
  const [settings, setSettings] = useState({ program_msg: '', program_footer: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [tab, setTab] = useState('requests');

  useEffect(() => { load(); }, []);
  async function load() {
    setLoading(true);
    const [r, s] = await Promise.all([api.get('/program-requests'), api.get('/program-settings')]);
    if (r?.requests) setRequests(r.requests);
    if (s?.settings) setSettings(p => ({ ...p, ...s.settings }));
    setLoading(false);
  }
  async function save() {
    setSaving(true);
    const d = await api.post('/program-settings', { updates: settings });
    if (d?.success) toast.success('Save ho gaya!'); else toast.error(d?.error || 'Error');
    setSaving(false);
  }

  if (loading) return <div style={{ textAlign: 'center', padding: 60 }}><span className="spinner" style={{ width: 32, height: 32 }} /></div>;

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <div className="section-title">📅 Program Info</div>
          <div className="section-sub">Program requests aur message settings</div>
        </div>
        <div style={{ padding: '4px 12px', borderRadius: 20, fontSize: 12, background: 'var(--emerald-900)', border: '1px solid var(--emerald-700)', color: 'var(--emerald-300)' }}>
          {requests.length} Requests
        </div>
      </div>

      <div style={{ display: 'flex', gap: 4, marginBottom: 20, borderBottom: '1px solid var(--border)' }}>
        {['requests', 'settings'].map(t => (
          <button key={t} onClick={() => setTab(t)} style={{ padding: '8px 16px', background: 'none', border: 'none', borderBottom: tab === t ? '2px solid var(--emerald-400)' : '2px solid transparent', color: tab === t ? 'var(--emerald-300)' : 'var(--text-muted)', cursor: 'pointer', fontSize: 13, fontWeight: tab === t ? 600 : 400, marginBottom: -1 }}>
            {t === 'requests' ? `📋 Requests (${requests.length})` : '⚙️ Settings'}
          </button>
        ))}
      </div>

      {tab === 'requests' && (
        requests.length === 0
          ? <div className="card" style={{ textAlign: 'center', padding: 40, color: 'var(--text-muted)' }}><Calendar size={32} style={{ marginBottom: 12, opacity: 0.4 }} /><div>Koi program request nahi</div></div>
          : <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {requests.map((r, i) => (
                <div key={i} className="card" style={{ padding: '12px 16px' }}>
                  <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 6 }}>{new Date(r.created_at).toLocaleString('ur-PK')}</div>
                  <div style={{ fontSize: 13, color: 'var(--text-primary)', whiteSpace: 'pre-wrap', lineHeight: 1.7 }}>{r.message?.replace('Naya Program Request!\n\nDetails:\n', '')}</div>
                </div>
              ))}
            </div>
      )}

      {tab === 'settings' && (
        <div style={{ maxWidth: 560 }}>
          <div className="card">
            <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 20 }}>⚙️ Program Bot Message</div>
            <div className="field">
              <label className="label">Bot ka Instruction Message</label>
              <textarea className="textarea" value={settings.program_msg} onChange={e => setSettings(p => ({ ...p, program_msg: e.target.value }))} disabled={!can('settings')} style={{ minHeight: 100 }} placeholder="Mehrbani farma kar ek hi message mein yeh 3 cheezein likhain..." />
            </div>
            <div className="field">
              <label className="label">Footer</label>
              <input className="input" value={settings.program_footer} onChange={e => setSettings(p => ({ ...p, program_footer: e.target.value }))} disabled={!can('settings')} />
            </div>
            {can('settings') && (
              <button className="btn btn-primary" onClick={save} disabled={saving}>
                {saving ? <span className="spinner" style={{ width: 14, height: 14 }} /> : <Save size={14} />}
                {saving ? ' Saving...' : ' Save Karein'}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default ProgramInfo;